import React, { useState } from 'react';
import { Wrench, X } from 'lucide-react';
import { logRigFault } from '@/lib/kiosk';

export default function LogFaultModal({ rig, user, onClose, onSaved }) {
  const [description, setDescription] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const save = async () => {
    if (!description.trim()) {
      setError('Describe the fault before saving.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await logRigFault({ rig, description: description.trim(), user });
      onSaved();
    } catch (e) {
      setError(e.message || 'Could not save the fault.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-6">
      <div className="w-full max-w-lg border border-white/10 bg-[#111115]">
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <div className="flex items-center gap-2.5">
            <Wrench className="w-4 h-4 text-primary" />
            <p className="text-white font-bold text-sm tracking-widest">LOG FAULT — {rig.bay_number}</p>
          </div>
          <button onClick={onClose} className="text-white/50 hover:text-white p-2">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5">
          <p className="text-white/40 text-xs font-bold tracking-widest uppercase mb-2">{rig.name}</p>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={5}
            autoFocus
            placeholder="What's wrong with this bay? e.g. 'Right paddle shifter not registering'"
            className="w-full bg-black/40 border border-white/15 focus:border-primary/60 text-white text-sm px-4 py-3 outline-none resize-none placeholder:text-white/25"
          />
          {error && <p className="text-red-400 text-xs mt-3">{error}</p>}

          <div className="flex gap-3 mt-5">
            <button
              onClick={onClose}
              className="flex-1 border border-white/15 hover:border-white/35 text-white/70 font-bold text-xs tracking-widest py-4 transition-colors"
            >
              CANCEL
            </button>
            <button
              onClick={save}
              disabled={saving}
              className="flex-1 bg-primary hover:bg-primary/90 disabled:opacity-50 text-white font-black text-xs tracking-widest py-4 transition-colors"
            >
              {saving ? 'SAVING…' : 'RECORD FAULT'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}